/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';
import useIOSInfo from 'bundles/composable-page-header/hooks/useIOSInfo';

const styles = {
  wrapper: css`
    padding-top: var(--cds-spacing-100);
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    margin-top: var(--cds-spacing-100);
  `,
};

const GetAppMenuItem = () => {
  const iosButtonInfo = useIOSInfo();

  if (!iosButtonInfo) {
    return null;
  }

  return (
    <div css={styles.wrapper}>
      <MobileButton {...iosButtonInfo} />
    </div>
  );
};

export default GetAppMenuItem;
